import { useState, useEffect } from "react"

export const useInViewport = (ref) => {
  const [is_intersecting, set_intersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => set_intersecting(entry.isIntersecting),
      { rootMargin: "-25% 0%", threshold: 1 }
    )

    if (!!ref?.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [ref]) // eslint-disable-line react-hooks/exhaustive-deps

  return { is_intersecting }
}
